// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + ".apljwihh8ok." + {"634":"f4220138","698":"175ec1db","967":"14f38c38","985":"65bbb9f7"}[chunkId] + ".chunk.css";
};